<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="640px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item prop="name" label="班次名称" > 
                    <el-input style="width:200px;" v-model="form.name" maxlength="20"  placeholder=""></el-input> 
                </el-form-item>

                <el-form-item prop="name" label="设置班次" >
                    <el-select v-model="form.classesType" placeholder="请选择" style="width:200px;">
                        <el-option
                            v-for="item in classesTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <br/><div style="font-size:10px;color:red">注：设置该班次一天内上下班的次数</div>
                </el-form-item>
 
                <table style="width: 100%;font-size: 14px">
                    <tr style="background-color: #F6F7FB;">
                        <th style="width:50%;">上下班时间</th>
                        <th style="width:50%;">打卡范围限制<span style="color:red">（时间设置不能重叠）</span></th>
                    </tr>
                    <tr>
                        <td>
                            第1次&nbsp;上班
                            <el-time-select  style="width:100px" 
                                placeholder="08:00"
                                v-model="form.oneCommuteTime1"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                        </td>
                        <td>
                            <el-time-select  style="width:100px" 
                                placeholder="07:00"
                                v-model="form.up1StartTimeRange"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                            至
                            <el-time-select  style="width:100px" 
                                placeholder="09:00"
                                v-model="form.up1EndTimeRange"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                            可打上班卡
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left:40px;">
                            下班
                            <el-time-select  style="width:100px" 
                                placeholder="11:00"
                                v-model="form.oneCommuteTime2"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                        </td>
                        <td>
                            <el-time-select  style="width:100px" 
                                placeholder="10:00"
                                v-model="form.down1StartTimeRange"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                            至
                            <el-time-select  style="width:100px" 
                                placeholder="12:00"
                                v-model="form.down1EndTimeRange"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                            可打下班卡
                        </td>
                    </tr>
                    
                    <tr v-if="form.classesType == 2">
                        <td>
                            第2次&nbsp;上班
                            <el-time-select  style="width:100px" 
                                placeholder="13:30"
                                v-model="form.twoCommuteTime1"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                        </td>
                        <td>
                            <el-time-select  style="width:100px" 
                                placeholder="13:00"
                                v-model="form.up2StartTimeRange"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                            至
                            <el-time-select  style="width:100px" 
                                placeholder="14:30"
                                v-model="form.up2EndTimeRange"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                            可打上班卡
                        </td>
                    </tr>
                    <tr v-if="form.classesType == 2">
                        <td style="padding-left:40px;">
                            下班
                            <el-time-select  style="width:100px" 
                                placeholder="17:00"
                                v-model="form.twoCommuteTime2"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                        </td>
                        <td>
                            <el-time-select  style="width:100px" 
                                placeholder="16:00"
                                v-model="form.down2StartTimeRange"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                            至
                            <el-time-select  style="width:100px" 
                                placeholder="20:00"
                                v-model="form.down2EndTimeRange"
                                :picker-options="{
                                start: '00:00',
                                step: '00:05',
                                end: '23:59'
                                }">
                            </el-time-select>
                            可打下班卡
                        </td>
                    </tr>
                </table>
                <div style="margin-top:20px;">
                    <el-checkbox v-model="form.clockOutSign">下班不用打卡（开启后，下班不打卡也不会记作异常）</el-checkbox>
                </div>
                <el-divider></el-divider>
                <div>
                    <div style="font-size:14px;font-weight:bold;margin-bottom:10px;">人性化班次：</div>
                    <el-checkbox v-model="form.lateMinuteSign">允许迟到分钟数</el-checkbox>
                    <el-input style="width:80px;" type="number" v-model="form.lateMinute" maxlength="20"  placeholder=""></el-input>
                </div>
                <el-divider></el-divider>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                addDateVisible:false,
                form:{
                    id:"",
                    name:"",
                    classesType:"",
                    oneCommuteTime1:"",
                    oneCommuteTime2:"",
                    twoCommuteTime1:"",
                    twoCommuteTime2:"",
                    up1StartTimeRange:"",
                    up1EndTimeRange:"",
                    down1StartTimeRange:"",
                    down1EndTimeRange:"",
                    up2StartTimeRange:"",
                    up2EndTimeRange:"",
                    down2StartTimeRange:"",
                    down2EndTimeRange:"",
                    clockOutSign:false,
                    lateMinuteSign:false,
                    lateMinute:""
                },
                rules: {
                    name: [
                        { required: true, message: '请输入班次名称', trigger: 'blur' }
                    ]
                },
                classesTypes:[{
                    value: 1,
                    label: '1天1次上下班'
                }, {
                    value: 2,
                    label: '1天2次上下班'
                }
                // , {
                //     value: 3,
                //     label: '1天3次上下班'
                // }
                ]
            }
        },
        components: {
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=data.id;
                this.form.name=data.name;
                this.form.classesType=data.classesType;
                this.form.oneCommuteTime1=data.oneCommuteTime.split("-")[0];
                this.form.oneCommuteTime2=data.oneCommuteTime.split("-")[1];
                
                if(data.classesType ==2 ){
                    this.form.twoCommuteTime1=data.twoCommuteTime.split("-")[0];
                    this.form.twoCommuteTime2=data.twoCommuteTime.split("-")[1];
                }
                
                this.form.up1StartTimeRange=data.up1StartTimeRange;
                this.form.up1EndTimeRange=data.up1EndTimeRange;
                this.form.down1StartTimeRange=data.down1StartTimeRange;
                this.form.down1EndTimeRange=data.down1EndTimeRange;
                this.form.up2StartTimeRange=data.up2StartTimeRange;
                this.form.up2EndTimeRange=data.up2EndTimeRange;
                this.form.down2StartTimeRange=data.down2StartTimeRange;
                this.form.down2EndTimeRange=data.down2EndTimeRange;
                this.form.clockOutSign=(data.clockOutSign==1?true:false);
                if(data.lateMinute !=null){
                    this.form.lateMinuteSign=true;
                    this.form.lateMinute=data.lateMinute;
                }else{
                    this.form.lateMinuteSign=false;
                    this.form.lateMinute=30;
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        if(this.$util.isEmpty(this.form.oneCommuteTime1)){
                            this.form.oneCommuteTime1="08:00";
                        }
                        if(this.$util.isEmpty(this.form.oneCommuteTime2)){
                            this.form.oneCommuteTime2="11:00"
                        }
                        
                        // 初始范围时间
                        if(this.$util.isEmpty(this.form.up1StartTimeRange)){
                            this.form.up1StartTimeRange="07:00"
                        }
                        if(this.$util.isEmpty(this.form.up1EndTimeRange)){
                            this.form.up1EndTimeRange="09:00"
                        }
                        if(this.$util.isEmpty(this.form.down1StartTimeRange)){
                            this.form.down1StartTimeRange="10:00"
                        }
                        if(this.$util.isEmpty(this.form.down1EndTimeRange)){
                            this.form.down1EndTimeRange="12:00"
                        }

                        
                        // 如果选择第2班次，第二次上下班必填
                        if(this.form.classesType == 2){
                             if(this.$util.isEmpty(this.form.twoCommuteTime1)){
                                this.form.twoCommuteTime1="13:30";
                             }
                             if(this.$util.isEmpty(this.form.twoCommuteTime2)){
                                this.form.twoCommuteTime2="17:00"
                             }

                             if(this.$util.isEmpty(this.form.up2StartTimeRange)){
                                this.form.up2StartTimeRange="13:00"
                             }
                             if(this.$util.isEmpty(this.form.up2EndTimeRange)){
                                this.form.up2EndTimeRange="14:30"
                             }
                             if(this.$util.isEmpty(this.form.down2StartTimeRange)){
                                this.form.down2StartTimeRange="16:00"
                             }
                             if(this.$util.isEmpty(this.form.down2EndTimeRange)){
                                this.form.down2EndTimeRange="20:00"
                             }
                        }else{
                            this.form.twoCommuteTime1="";
                            this.form.twoCommuteTime2="";
                            this.form.up2StartTimeRange="";
                            this.form.up2EndTimeRange="";
                            this.form.down2StartTimeRange="";
                            this.form.down2EndTimeRange="";
                        }
 
                        let url= this.classesUpdateUrl;
                        let data = {
                            id:this.form.id,
                            name:this.form.name,
                            classesType:this.form.classesType,
                            oneCommuteTime:this.form.oneCommuteTime1+"-"+this.form.oneCommuteTime2,
                            up1StartTimeRange:this.form.up1StartTimeRange,
                            up1EndTimeRange:this.form.up1EndTimeRange,
                            down1StartTimeRange:this.form.down1StartTimeRange,
                            down1EndTimeRange:this.form.down1EndTimeRange,
                            up2StartTimeRange:this.form.up2StartTimeRange,
                            up2EndTimeRange:this.form.up2EndTimeRange,
                            down2StartTimeRange:this.form.down2StartTimeRange,
                            down2EndTimeRange:this.form.down2EndTimeRange,
                            clockOutSign:this.form.clockOutSign?1:2
                        };

                        if(this.form.classesType == 2){
                            data.twoCommuteTime=this.form.twoCommuteTime1+"-"+this.form.twoCommuteTime2;
                        }else{
                            data.twoCommuteTime='';
                        }

                        if(this.form.lateMinuteSign){
                            data.lateMinute=this.form.lateMinute;
                        }else{
                            data.lateMinute="";
                        }
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
    .el-row {
        margin-bottom: 20px;
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 20px;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/attendance/classes/Update.vue